{
  "id": "steel",
  "displayName": "Steel",
  "solid": true,
  "destructible": false,
  "displayColor": "#9aa0a6"
}
